import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

// 扩展 dayjs 插件
dayjs.extend( utc );
dayjs.extend( timezone );

/**
 * 格式化为印度时间 (Asia/Kolkata)
 * @param timestamp - 时间戳 (支持毫秒、秒、Date 对象或字符串)
 * @param format - 格式化字符串，默认为 "YYYY-MM-DD HH:mm:ss"
 * @returns 格式化后的印度时间字符串
 */
export function formatIndiaDate(
    timestamp: number | string | Date,
    format: string = "YYYY-MM-DD HH:mm:ss",
): string {
    if ( !timestamp ) return "";

    let date = dayjs( timestamp );

    // 处理 10 位数的时间戳（秒级别）
    if ( typeof timestamp === "number" && timestamp.toString().length === 10 ) {
        date = dayjs.unix( timestamp );
    }

    return date.tz( "Asia/Kolkata" ).format( format );
}
